export function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') resolve(reader.result);
      else reject(new Error('Falha ao ler imagem'));
    };
    reader.onerror = () => reject(reader.error || new Error('Falha ao ler imagem'));
    reader.readAsDataURL(file);
  });
}

const MAX_IMAGE_BYTES = 5 * 1024 * 1024; // 5 MB

export function isAcceptableImage(file: File): boolean {
  if (!file.type.startsWith('image/')) return false;
  if (file.size > MAX_IMAGE_BYTES) return false;
  return true;
}
